import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseResponse } from '../../../shared/models/base-api-response.interface';
import { endpoint, httpOptions } from '../../../shared/apis/endpoint';
import { environment as env } from '../../../../environments/environment';
import { PacienteEdit } from '../models/paciente.interface';

@Injectable({
  providedIn: 'root'
})
export class PacienteService {

  constructor(
    private _http: HttpClient) { }

  PacienteById(id: number): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.PACIENTE_GET_BY_ID}${id}`
    return this._http.get(requestUrl).pipe(
      map((resp: any) => resp as BaseResponse)
    );
  }

  PacienteEdit(id: number, paciente: PacienteEdit): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.PACIENTE_EDIT}${id}`
    return this._http.put(requestUrl, paciente, httpOptions).pipe(
      map((resp: BaseResponse) => {
        return resp
      })
    )
  }

  PacienteEdadMinima(historia: number): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.PACIENTE_EDAD_MINIMA}${historia}`
    return this._http.get(requestUrl).pipe(
      map((resp: any) => resp as BaseResponse)
    );
  }

}
